import { PartialType, PickType } from '@nestjs/swagger';
import { MaterialDto } from './material.dto';
import { MaterialUpdatableInterface } from '../interfaces/material-updatable.interface';

export class MaterialUpdateDto
  extends PartialType(
    PickType(MaterialDto, ['name', 'description', 'unit', 'amount']),
  )
  implements MaterialUpdatableInterface {}
